// @flow
import React from 'react'

// core
import { patchSpecification, patchContent } from '../PatchFunctions'

// types
import type { ExpandedSpecificationDTO, SpecificationPatchType } from '../Types/Field'
import type { ProductContent, ProductPatchType } from '../Types/ProductContent'

type PatchSpecificationProps = {
  children: any,
  specification: ExpandedSpecificationDTO,
  specificationPatch?: SpecificationPatchType,
  content: ProductContent,
  contentPatch?: ProductPatchType,
}

type PatchSpecificationState = {
  rawSpecification?: ExpandedSpecificationDTO,
  specification?: ExpandedSpecificationDTO,
  rawContent?: ProductContent,
  content?: ProductContent,
}

export default class PatchSpecification extends React.Component<PatchSpecificationProps, PatchSpecificationState> {
  static getDerivedStateFromProps = (nextProps: PatchSpecificationProps, prevState: PatchSpecificationState) => {
    if (
      JSON.stringify(nextProps.specification) !== JSON.stringify(prevState.rawSpecification) ||
      JSON.stringify(nextProps.content) !== JSON.stringify(prevState.content)
    ) {
      return {
        rawSpecification: nextProps.specification,
        specification: patchSpecification(nextProps.specification, nextProps.specificationPatch),
        rawContent: nextProps.content,
        content: patchContent(nextProps.content, nextProps.contentPatch),
      }
    }

    return null
  }

  state = {}

  render = () => {
    if (!this.props.content || !this.props.content.fieldOrder || !this.props.specification || !this.props.specification.fields) {
      return null
    }

    return React.Children.map(this.props.children, (child) =>
      React.cloneElement(child, {
        ...child.props,
        specification: this.state.specification,
        content: this.state.content,
      })
    )
  }
}
